export default "__VITE_ASSET__O$Tx4xFo__"